import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="min-h-screen pt-[100px] sm:pt-[130px] px-5 sm:px-6 md:px-[48px] pb-[40px] sm:pb-[60px] flex flex-col relative overflow-hidden border-b border-tux-border bg-tux-dark" data-id="element-77">
      {/* Subtle dot-grid background */}
      <div className="absolute inset-0 dot-grid-dark pointer-events-none opacity-40" data-id="element-78" />

      {/* Main Content - Centered */}
      <div className="flex-1 flex flex-col items-center justify-center relative z-10 w-full max-w-[1440px] mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full flex flex-col items-center justify-center" data-id="element-80">
          {/* First Line: Solid White */}
          <h1 className="font-display font-black text-[clamp(42px,11vw,160px)] leading-[0.85] uppercase text-white tracking-[-0.01em] text-center w-full mb-[-2%] relative z-20" data-id="element-81">
            NOT A LISTING.
          </h1>

          {/* Second Line: Neon Glow */}
          <h1 className="font-display font-black text-[clamp(42px,11vw,160px)] leading-[0.85] uppercase text-tux-lime tracking-[-0.01em] text-center w-full relative z-20" style={{
          textShadow: '0 0 10px rgba(200,255,0,0.6), 0 0 30px rgba(200,255,0,0.35), 0 0 60px rgba(200,255,0,0.2), 0 0 100px rgba(200,255,0,0.1)'
        }} data-id="element-82">
            A LAUNCH.
          </h1>
        </motion.div>

        {/* Description Text - Bottom Right */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 0.8
      }} transition={{
        duration: 1,
        delay: 1.5
      }} className="absolute bottom-4 right-0 max-w-[220px] text-right hidden md:block" data-id="element-83">
          <p className="font-sans font-light text-[13px] leading-[1.6] text-white" data-id="element-84">
            Bespoke property marketing for Melbourne's best agents and
            developers.
          </p>
        </motion.div>
      </div>

      {/* Mobile Description (visible only on small screens) */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 0.8
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="w-full text-center mt-auto md:hidden relative z-10 pt-8" data-id="element-85">
        <p className="font-sans font-light text-[13px] leading-[1.6] text-white max-w-[280px] mx-auto" data-id="element-86">
          Bespoke property marketing for Melbourne's best agents and developers.
        </p>
      </motion.div>
    </section>;
}